import { useContext, useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import useSession from '../hooks/useSession';
import { Link } from 'react-router-dom'
import authAPI from '../services/auth'
import { UserContext } from '../context/UserContext';
import Toast from './layout/Toast'
import { ErrorContext } from '../context/ErrorContext';

const Auth = () => {
  const [session, setSession] = useSession()
  const { user, setAuthUser } = useContext(UserContext)
  const [error, setError] = useState([])
  const navigate = useNavigate();
  const { parseErrors } = useContext(ErrorContext)
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const {
    email,
    password,
  } = formData;
  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value})
  const onSubmit = async (e) => {
    e.preventDefault()
    setError([]);
    try {
      const res = await authAPI.post({email, password})
      setSession(res.data.data.token);
      await getUserData(res.data.data.token)
    } catch (err) {
      const parsedErr = parseErrors(err.response.data.error)
      setError(parsedErr)
      // setError(err.response.data.errors.map(e => <p>{e.msg}</p>))
    }
  }

  useEffect(() => {
    if (session && user) {
      roleManager(user)
    }
  }, [])

  const getUserData = async (jwt) => {
    const res = await authAPI.get({ jwt })
    setAuthUser(res.data.data)
    roleManager(res.data.data)
  }

  const roleManager = (user) => {
    switch (user.position) {
      case 'admin':
        return navigate('/register')    
      case 'am':
        return navigate('/widget#dashboard')  
      default:
        return navigate('/login')
    }
  }

  return (
    <>
      <section className='w-3/5 m-auto my-10 text-[#152536]'>
        <h1 className='font-bold text-[40px] leading-[60px] text-center'>Sign In</h1>
        <p className='font-normal text-[#68717A] mt-4 text-center'>Welcome back! A new session need to be started. Please, enter your email and password to sign in.</p>
        <form className='w-4/6 m-auto my-12 text-base' onSubmit={e => onSubmit(e)}>
          <div className='mb-4'>
            <label htmlFor="email" className='block font-semibold'>Email*</label>
            <input id="email"
              className='block w-full h-9 my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded'
              type="email"
              placeholder="someone@email.com"
              onChange={ e => onChange(e) }
              name="email"
              required
            />
          </div>
          <div className='mb-4'>
            <label htmlFor="password" className='block font-semibold'>Password*</label>
            <input id="password"
              className='block w-full h-9 my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded'
              type="password"
              onChange={ e => onChange(e) }
              placeholder="Password"
              name="password"
            />
          </div>
          <input
            type="submit"
            className="font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-4 py-2 rounded focus:outline-none"
            value="Sign in"
          />
        </form>
      </section>
      <Toast toast={error} time={3000} />
    </>
  )
}

export default Auth